import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import styles from "./index.module.sass";
import { CompetitionsType, CompetitionType, CompetitionTypes } from "../../services/CompetitionsService";
import { currencyNeutreFormatter } from "../../utils/numberFormatter";
import { PrimaryButton } from "@fluentui/react";
import Auth from "../../Auth/Auth";
import { ErrorModal } from "../Modals/ErrorModal";
import { createurl } from "../../utils/createUrl";

interface CompetitionCardProps
{
	competition: CompetitionsType
	toJoin?: boolean;
}

const CompetitionCard: React.FC<CompetitionCardProps> = ({
	competition,
	toJoin
}) =>
{
	const history = useHistory();
	const isUserSuscribed = Auth.isSubscribed();
	const activePlan = Auth.getActivePlan();
	const user: any = Auth.getUserProfile();

	const [error, setError] = useState({ status: false, message: "" });

	const formatDate = (date: string) =>
	{
		const [month, day, year] = date.split("/");
		return `${day}/${month}/${year}`;
	};


	const truncateHtml = (html: string, limit: number): string => 
	{
		const textContent = html.replace(/<\/?[^>]+(>|$)/g, ""); // Elimina etiquetas HTML
		if (textContent.length > limit)
		{
			const truncatedText = textContent.substring(0, limit) + "...";
			return truncatedText;
		}
		return textContent;
	}

	const isCompetitionIniciated = () =>
	{
		if (competition?.startDate != undefined && new Date(competition?.startDate) <= new Date())
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	return (
		<article
			className={`rounded background-background`}
			style={{
				marginRight: "20px",
				boxShadow: "0 0 5px 3px rgb(0 0 0 / 8%)",
				paddingTop: "10px",
				paddingLeft: "16px",
				paddingRight: "16px",
				height: "240px",
				width: "390px",
				marginTop: "5px",
				marginBottom: "5px"
			}}
		>

			<header>
				<div
					style={{
						display: "flex",
						marginTop: "10px",
						height: "50px",
						alignContent: "center",
						justifyContent: "space-between",
					}}
				>
					<div style={{ display: "flex", flexDirection: "column" }}>
						<p
							style={{
								marginBottom: "0px",
								fontSize: "16px",
								fontWeight: "600",
								wordBreak: "break-word",
							}}
						>
							{competition.name}
						</p>
						<span className="color-neutralTertiaryAlt">
							Del {formatDate(competition.startDate)} al {formatDate(competition.endDate)}
						</span>
					</div>
					<span className={styles.type}>
						Tipo: {CompetitionTypes[competition.type]}
					</span>
				</div>
			</header>
			<main
				style={{
					marginTop: "10px",
					whiteSpace: "normal",
					height: "100px"
				}}
				dangerouslySetInnerHTML={{
					__html: truncateHtml(competition.description ?? "", 400),
				}}
			/>

			<div
				style={{
					position: "relative",
					width: "100%",
					height: "190px",
				}}
			>
				<footer
					style={{
						backgroundColor: "white",
						width: "100%",
						fontSize: "14px",
						fontWeight: "500",
						display: "flex",
						justifyContent: "space-between",
						boxSizing: "border-box",
					}}
				>
					<div>
						<span>
							{competition.price === 0 && <>Inscripción gratuita</>}
							{competition.price !== 0 && competition.typeOfPrice === 0 && <>{currencyNeutreFormatter.format(competition.price)} Elements IA</>}
							{competition.price !== 0 && competition.typeOfPrice === 1 && <>{currencyNeutreFormatter.format(competition.price)} El. Agua</>}
							{competition.price !== 0 && (competition.typeOfPrice === 2 || competition.typeOfPrice === 3) && <>{currencyNeutreFormatter.format(competition.price)} €</>}
						</span>
						<p>Participantes: {competition.isPromocionated == true ? competition.totalParticipantsPromotionated : competition.totalParticipants}</p>
						{competition.price != 0 && <>
							<p className={styles.price}>
								Bote:{" "}
								{competition.typeOfPrice === 0 &&
									<>
										{competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.totalAmountPromotionated)}{" "} Elements IA </>}
										{competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.totalAmount)}{" "} Elements IA</>}
									</>
								}
								{competition.typeOfPrice === 1 &&
									<>
										{competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.totalAmountPromotionated)}{" "} Elements Agua </>}
										{competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.totalAmount)}{" "} Elements Agua</>}
									</>
								}
								{(competition.typeOfPrice === 2 || competition.typeOfPrice === 3) &&
									<>
										{competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.totalAmountPromotionated)}{" "} € </>}
										{competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.totalAmount)}{" "} €</>}
									</>
								}
							</p></>}
					</div>
					{toJoin !== true && <div style={{ display: "flex" }}>
						{(
							!competition.idUsers.some(e => e == user.id) 
							&& new Date(competition?.endDate) >= new Date()
							&& (competition.allowOutdatedIncriptions == true || ( competition.allowOutdatedIncriptions == false && !isCompetitionIniciated())) 
							) && <PrimaryButton
							className="rounded"
							style={{ marginLeft: "10px", width: "130px" }}
							onClick={() =>
							{
								//Es un plan gestionado
								if (activePlan.type == 0)
								{
									setError({ status: true, message: "Los planes de tipo gestionado no pueden participar en la competición. Actualmente tienes seleccionado como activo un plan de este tipo." })
								} else
								{
									isUserSuscribed
										? history.push(`/competitions/join/${competition.id}`)
										: history.push(`/competitions/join/nsv/${competition.id}`
										);
								}
							}}
						>
							Participar
						</PrimaryButton>
						}
						<PrimaryButton
							className="rounded"
							style={{ marginLeft: "10px", width: "130px" }}
							onClick={() =>
							{
								competition.isPromocionated
									? history.push(`/competition/${createurl(competition.name)}-${competition.id}`, { competitionId: competition.id })
									: history.push(`/competitions/${competition.id}`, { competitionId: competition.id });
							}}
						>
							Ver
						</PrimaryButton>
					</div>}

				</footer>
				{/* {competition.price !== 0 && (
                    <footer
                        style={{
                            backgroundColor: "white",
                            width: "100%",
                            fontSize: "14px",
                            fontWeight: "500",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "0 10px",
                            boxSizing: "border-box",
                            paddingLeft: "20px",
                            paddingRight: "20px",
                            paddingTop: "20px",
                            position: "absolute",
                            bottom: "20px",
                        }}
                    >
                        
                    </footer>
                )} */}
			</div>
			<ErrorModal
				title="Tu Plan actual no es compatible con la competición"
				body={
					<div>
						<p>{error.message}</p>
					</div>
				}
				btnSubmitText="Aceptar"
				showModal={error.status}
				onSubmit={() =>
				{
					setError({ status: false, message: "" });
				}}
				onClose={() =>
				{
					setError({ status: false, message: "" });
				}}
			/>
		</article>
	);
};

export default CompetitionCard;
